/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 * 
 **/
import { createIcon } from "@v2/helpers/icons/create-icon";
export const UnknownIcon = createIcon({
  displayName: "UnknownIcon",
  viewBox: "0 0 16 16",
  path: (<g fill="none"><path d="M5.24707 5.76327C5.24707 4.88557 5.96546 2.99539 8.58247 3.00001C11.1995 3.00463 11.5972 5.24664 11.5972 5.53865C11.5972 8.59507 7.99236 7.6736 7.99236 11.4809" stroke="currentColor" strokeWidth={1.5} /><rect x={7.625} y={13.0957} width={0.75} height={0.75} fill="currentColor" stroke="currentColor" strokeWidth={0.75} /></g>)
});